export default "__VITE_ASSET__c7waD8A2__"